import { jsxs, jsx } from 'react/jsx-runtime';
import { ReactComponent as ForwardRef } from '../../../../assets/icons/EllipsisVSmall.svg.js';
import Checkbox from '../../../Checkbox/Checkbox.js';
import '../../../Checkbox/CheckboxList.js';
import { Root, IconsWrapper, Icons, Text, PillContainer } from './styled.js';
import PillSmall from '../../../PillSmall/PillSmall.js';

const DragLayerPreview = ({ count, rtl, enableCheckboxSelection, checked }) => {
    return (jsxs(Root, Object.assign({ count: count, rtl: rtl }, { children: [enableCheckboxSelection && (jsx(IconsWrapper, { children: jsxs(Icons, Object.assign({ rtl: rtl }, { children: [jsx(ForwardRef, {}), jsx(Checkbox, { checked: checked })] })) })), jsx(Text, Object.assign({ variant: "body2", rtl: rtl, enableCheckboxSelection: enableCheckboxSelection }, { children: `Moving file${enableCheckboxSelection ? 's' : ''}...` })), enableCheckboxSelection && (jsx(PillContainer, Object.assign({ rtl: rtl }, { children: jsx(PillSmall, { children: count }) })))] })));
};

export { DragLayerPreview as default };
//# sourceMappingURL=DragLayerPreview.js.map
